import { Box, Button, TextField, useMediaQuery, useTheme } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useSelector } from "react-redux";
import { requester } from "api/pesabackend";

const RenumerationTypeSchema = yup.object().shape({
  renumeration_name: yup.string().required("required"),
});

const initialValuesRenumerationType = {
  renumeration_name: "",
};

const RenumerationTypeForm = (props) => {
  const pageType = props.formType;
  let { editData } = props;
  const userId = useSelector((state) => state.authReducer.user.userId);
  const business_id = useSelector((state) => state.authReducer.business_id);
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const { palette } = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const isNew = pageType === "create";
  const isEdit = pageType === "edit";

  const initialEditValuesRenumerationType = {
    renumeration_name: editData.renumeration_name,
  };

  const saveRenumerationType = async (values, onSubmitProps) => {
    values.related_business = business_id;
    values.related_business_branch = business_branch_id;
    values.added_by = userId;

    const savedResponse = await requester.post(`/human_resource/renumeration`, JSON.stringify(values));

    if (savedResponse.data.status === 201) {
      onSubmitProps.resetForm();
      props.setIsSuccess(true);
      props.setNewRenumerationTypeData(true);
      props.setOpen(false);
    }
  };

  const editRenumerationType = async (values, onSubmitProps) => {
    const savedResponse = await requester.post(`/human_resource/renumeration/edit/${editData.id}`, JSON.stringify(values));

    if (savedResponse.data.status === 201) {
      onSubmitProps.resetForm();
      props.setIsSuccess(true);
      props.setNewRenumerationTypeData(true);
      props.setOpen(false);
    }
  };

  const handleFormSubmit = async (values, onSubmitProps) => {
    if (isNew) await saveRenumerationType(values, onSubmitProps);
    if (isEdit) await editRenumerationType(values, onSubmitProps);
  };

  return (
    <Formik
      onSubmit={handleFormSubmit}
      initialValues={
        isNew
          ? initialValuesRenumerationType
          : initialEditValuesRenumerationType
      }
      validationSchema={RenumerationTypeSchema}
    >
      {({
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
      isSubmitting,
      }) => (
        <form onSubmit={handleSubmit}>
          <Box
            display="grid"
            gap="30px"
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            sx={{
              "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
            }}
          >
            <TextField
              label="Renumeration Type Name"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.renumeration_name}
              name="renumeration_name"
              error={
                Boolean(touched.renumeration_name) &&
                Boolean(errors.renumeration_name)
              }
              helperText={touched.renumeration_name && errors.renumeration_name}
              sx={{ gridColumn: "span 4" }}
            />
          </Box>

          {/* BUTTONS */}
          <Box>
            <Button
              fullWidth
              type="submit"
              disabled={isSubmitting}
              sx={{
                m: "1rem 0",
                p: "1rem",
                backgroundColor: palette.primary.main,
                color: palette.background.alt,
                "&:hover": { color: palette.primary.main },
              }}
            >
              Save
            </Button>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default RenumerationTypeForm;
